import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import InviteLink from '../InviteLink/InviteLink'
import BirdImage from './BirdImage/BirdImage'

import messages from './messages'
import s from './ThankYouForOrder.scss'


const ThankYouForOrder = ({ gender }) => (
  <div data-testid={constants.testIds.thankYouPage.addPerfumeToQueueCountdown}>
    <BirdImage />
    <Box mt="36">
      <Text className={s.title} tag="h2" message={messages.thankYou} />
    </Box>
    <InviteLink gender={gender} />
  </div>
)

ThankYouForOrder.propTypes = {
  gender: PropTypes.string.isRequired,
}


export default ThankYouForOrder
